<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-pagos-paginados"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import { mapGetters } from 'vuex';
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { formatearValorAMoneda } from '../utils/funciones';

export default {
  name: 'ListadoSolicitudesPagosPadresPaginados',
  mixins: [listadoAgGridMixin],
  mounted() {
    this.toggleColumnVisibility('headerName', 'DETALLE', this.getMostradoDetalleSolicitudesPagosAgrupados);
  },
  computed: {
    ...mapGetters({
      getMostradoDetalleSolicitudesPagosAgrupados: 'listado/getMostradoDetalleSolicitudesPagosAgrupados',
    }),
  },
  watch: {
    getMostradoDetalleSolicitudesPagosAgrupados(value) {
      this.toggleColumnVisibility('headerName', 'DETALLE', value);
    },
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° SOLICITUD',
          field: 'numeroSolicitud',
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'SOLICITANTE',
          field: 'nombreSolicitante',
          filter: true,
          minWidth: 200,
        },
        {
          headerName: 'FECHA SOLICITUD',
          field: 'fechaSolicitud',
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'SEDE',
          field: 'sede.nombre',
          filter: true,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'N° EST. SOLIC.',
          cellRenderer: (params) => {
            const solicitudesPagos = params.data.solicitudesPagos;
            let nroEstudiantes = 0;

            for (let i = 0; i < solicitudesPagos.length; i++) {
              nroEstudiantes += solicitudesPagos[i].detallesSolicitudesPagos.length;
            }

            return nroEstudiantes;
          },
          type: 'numericColumn',
          filter: false,
          minWidth: 125,
          maxWidth: 125,
        },
        {
          headerName: 'MONTO TOTAL',
          cellRenderer: (params) => {
            const solicitudesPagos = params.data.solicitudesPagos;

            let montoTotal = 0;

            for (let i = 0; i < solicitudesPagos.length; i++) {
              const solicitudPago = solicitudesPagos[i];

              for (let j = 0; j < solicitudPago.detallesSolicitudesPagos.length; j++) {
                const detallePlanPagoConceptoUniversidad = solicitudPago.detallePlanPagoConceptoUniversidad;

                montoTotal += Number(detallePlanPagoConceptoUniversidad.monto);
              }
            }

            return formatearValorAMoneda(montoTotal);
          },
          type: 'numericColumn',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'DETALLE',
          headerComponentParams: {
            template: /* html */ `
              <table width="100%" style="border-collapse">
                <tr>
                  <th style="font-size: 13px; font-weight: 600; min-width: 70px; width: 70px;">#</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 100px; width: 100px;">N° SOLICITUD</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 150px; width: 150px;">N° DOCUMENTO</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 150px; width: 150px;">PRIMER APELLIDO</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 150px; width: 150px;">SEGUNDO APELLIDO</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 150px; width: 150px;">NOMBRES</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 150px; width: 150px;">CONCEPTO</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 100px; width: 100px;">N° CUOTA</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 100px; width: 100px;">MONTO</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 200px; width: 200px;">ESTA PAGADO</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 680px; width: 680px;">PROGRAMA UNIVERSIDAD</th>
                  <th style="font-size: 13px; font-weight: 600; min-width: 450px; width: 450px;">PROGRAMA</th>
                </tr>
              </table>
            `,
          },
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            }

            let detalle = /* html*/ `
            <table width="100%" style="border-collapse: collapse;">`;

            const solicitudesPagos = params.data.solicitudesPagos;
            let nro = 0;

            for (let i = 0; i < solicitudesPagos.length; i++) {
              const solicitudPago = solicitudesPagos[i];
              const programaUniversidad = solicitudPago.programaUniversidad;

              for (let j = 0; j < solicitudPago.detallesSolicitudesPagos.length; j++) {
                const detalleSolicitudPago = solicitudPago.detallesSolicitudesPagos[j];
                const inscripcion = detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion;
                const estudiante = inscripcion.estudiante;
                const programa = inscripcion.programa;
                const planPagoConceptoUniversidad =
                  solicitudPago.detallePlanPagoConceptoUniversidad.planPagoConceptoUniversidad;
                const color = detalleSolicitudPago?.detallePagoUniversidad ? 'green' : 'red';
                nro++;

                detalle += /* html */ `
                <tr>
                  <td style="font-size: 13px; min-width: 70px; width: 70px;">${nro}</td>
                  <td style="font-size: 13px; min-width: 100px; width: 100px; text-align: right; padding-right: 20px;">
                    ${solicitudPago.numeroSolicitud}
                  </td>
                  <td style="font-size: 13px; min-width: 150px; width: 150px;">${estudiante.numeroDocumento}</td>
                  <td style="font-size: 13px; min-width: 150px; width: 150px;">${estudiante.primerApellido}</td>
                  <td style="font-size: 13px; min-width: 150px; width: 150px;">${estudiante.segundoApellido}</td>
                  <td style="font-size: 13px; min-width: 150px; width: 150px;">${estudiante.nombres}</td>
                  <td style="font-size: 13px; min-width: 150px; width: 150px;">
                    ${planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre}
                  </td>
                  <td style="font-size: 13px; min-width: 100px; width: 100px; text-align: right; padding-right: 20px;">
                    ${formatearValorAMoneda(solicitudPago.detallePlanPagoConceptoUniversidad.monto)}
                  </td>
                  <td style="font-size: 13px; min-width: 100px; width: 100px; text-align: right; padding-right: 20px;">
                    ${solicitudPago.detallePlanPagoConceptoUniversidad.numeroCuota}
                  </td>
                  <td style="max-width: 200px; width: 200px; overflow-x: hidden; border-bottom: 1px solid #d9dcde;">
                    <span class="v-chip v-chip--outlined theme--dark v-size--x-small ${color} ${color}--text" file="v-chip/usage">
                      <span class="v-chip__content">
                        ${detalleSolicitudPago.detallePagoUniversidad ? 'PAGADO' : 'NO PAGADO'}
                      </span>
                    </span>
                  </td>
                  <td style="font-size: 13px; min-width: 680px; width: 680px;">
                    ${programaUniversidad.codigo} - ${programaUniversidad.programaNombre}
                  </td>
                  <td style="font-size: 13px; min-width: 450px; width: 450px;">${programa.nombreCompuesto}</td>
                </tr>`;
              }
            }

            detalle += /* html */ `</table>`;

            return detalle;
          },
          valueGetter: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            }

            let detalle = '';

            const solicitudesPagos = params.data.solicitudesPagos;

            for (let i = 0; i < solicitudesPagos.length; i++) {
              const solicitudPago = solicitudesPagos[i];
              const programaUniversidad = solicitudPago.programaUniversidad;

              for (let j = 0; j < solicitudPago.detallesSolicitudesPagos.length; j++) {
                const detalleSolicitudPago = solicitudPago.detallesSolicitudesPagos[j];
                const inscripcion = detalleSolicitudPago.inscripcionProgramaUniversidad.inscripcion;
                const estudiante = inscripcion.estudiante;
                const programa = inscripcion.programa;
                const nro = i < 1 ? j + 1 : j + 1 + solicitudesPagos[i - 1].detallesSolicitudesPagos.length;

                detalle += `${nro}. ${estudiante.numeroDocumento} - ${estudiante.primerApellido} ${
                  estudiante.segundoApellido
                }, ${estudiante.nombres} - ${detalleSolicitudPago.detallePagoUniversidad ? 'PAGADO' : 'NO PAGADO'} - ${
                  programaUniversidad.codigo
                } - ${programaUniversidad.programaNombre} - ${programa.nombreCompuesto}\n`;
              }
            }

            return detalle;
          },
          autoHeight: true,
          suppressSizeToFit: true,
          filter: true,
          minWidth: 2200,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-pagos-paginados {
  height: calc(var(--vh, 1vh) * 100 - 19em);
}
</style>
  